import StrUtil from '../util/StrUtil';

function commonName(name:any, maxSize:any) {
    maxSize = maxSize || 128;

    // 空, 后端会使用默认名称, 前端认为通过
    if (!name) {
        return true;
    }
    var r = /^[\u4e00-\u9fa5a-zA-Z0-9\-_\\\/\(\)\、]+$/;
    if (!r.test(name)) {
        return false;
    }
    // 符合正则 再校验字数
    var len = StrUtil.sizeOf(name);
    return len <= maxSize;
}

function commonTel(name:any) {
    if (!name) {
        return true;
    }
    if (/^1(3|4|5|7|8)\d{9}$/.test(name)) {
        return true;
    }

    return false;
}

function commonEmail(name:any) {
    if (!name) {
        return true;
    }
    var filter = /^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
    if (filter.test(name)) {
        return true;
    } else {
        return false;
    }
}

const ipv6Reg = /^([\da-fA-F]{1,4}:){6}((25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(25[0-5]|2[0-4]\d|[01]?\d\d?)(\/([1-9]?\d|(1([0-1]\d|2[0-8]))))?$|^::([\da-fA-F]{1,4}:){0,4}((25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(25[0-5]|2[0-4]\d|[01]?\d\d?)(\/([1-9]?\d|(1([0-1]\d|2[0-8]))))?$|^([\da-fA-F]{1,4}:):([\da-fA-F]{1,4}:){0,3}((25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(25[0-5]|2[0-4]\d|[01]?\d\d?)(\/([1-9]?\d|(1([0-1]\d|2[0-8]))))?$|^([\da-fA-F]{1,4}:){2}:([\da-fA-F]{1,4}:){0,2}((25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(25[0-5]|2[0-4]\d|[01]?\d\d?)(\/([1-9]?\d|(1([0-1]\d|2[0-8]))))?$|^([\da-fA-F]{1,4}:){3}:([\da-fA-F]{1,4}:){0,1}((25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(25[0-5]|2[0-4]\d|[01]?\d\d?)(\/([1-9]?\d|(1([0-1]\d|2[0-8]))))?$|^([\da-fA-F]{1,4}:){4}:((25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(25[0-5]|2[0-4]\d|[01]?\d\d?)(\/([1-9]?\d|(1([0-1]\d|2[0-8]))))?$|^([\da-fA-F]{1,4}:){7}[\da-fA-F]{1,4}(\/([1-9]?\d|(1([0-1]\d|2[0-8]))))?$|^:((:[\da-fA-F]{1,4}){1,6}|:)(\/([1-9]?\d|(1([0-1]\d|2[0-8]))))?$|^[\da-fA-F]{1,4}:((:[\da-fA-F]{1,4}){1,5}|:)(\/([1-9]?\d|(1([0-1]\d|2[0-8]))))?$|^([\da-fA-F]{1,4}:){2}((:[\da-fA-F]{1,4}){1,4}|:)(\/([1-9]?\d|(1([0-1]\d|2[0-8]))))?$|^([\da-fA-F]{1,4}:){3}((:[\da-fA-F]{1,4}){1,3}|:)(\/([1-9]?\d|(1([0-1]\d|2[0-8]))))?$|^([\da-fA-F]{1,4}:){4}((:[\da-fA-F]{1,4}){1,2}|:)(\/([1-9]?\d|(1([0-1]\d|2[0-8]))))?$|^([\da-fA-F]{1,4}:){5}:([\da-fA-F]{1,4})?(\/([1-9]?\d|(1([0-1]\d|2[0-8]))))?$|^([\da-fA-F]{1,4}:){6}:(\/([1-9]?\d|(1([0-1]\d|2[0-8]))))?$/;

function commonIpv6(ip:any) {
    return ipv6Reg.test(ip);
}
function commonIpv4(ip:any) {
    return /^(((2[0-4]\d|25[0-5]|1\d\d|0|[1-9]\d?)\.){3}(2[0-4]\d|25[0-5]|1\d\d|0|[1-9]\d?)((,|\||;)((2[0-4]\d|25[0-5]|1\d\d|0|[1-9]\d?)\.){3}(2[0-4]\d|25[0-5]|1\d\d|0|[1-9]\d?))*)$/.test(ip)
}

export default {
    commonName,
    commonTel,
    commonEmail,
    commonIpv4,
    commonIpv6
};
